import { UpNextCalendarEventsLoaderScenarioId } from '../UpNextV2Constants';
import { updateUpNextCalendarIds } from 'owa-upnext-event-loader';
import { orchestrator } from 'satcheljs';
import {
    onSelectedCalendarIdsUpdated,
    getTimePanelSelectedCalendarIdsFlatList,
} from 'owa-time-panel-selected-calendar-ids';

// TODO: VSO #54134 Update Mail UpNext to take dependency on new package / selectors so that it stays in-sync

export const onSelectedCalendarIdsUpdatedOrchestrator = orchestrator(
    onSelectedCalendarIdsUpdated,
    actionMessage => {
        const selectedCalendars = getTimePanelSelectedCalendarIdsFlatList();
        updateUpNextCalendarIds(selectedCalendars, UpNextCalendarEventsLoaderScenarioId);
    }
);
